<template>
    <div class="md-layout">

        <div class="md-layout-item md-size-66">
            <form ref="category_add" @submit.prevent="updateDocumentType">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>edit</md-icon>
                        </div>
                        <h4 class="title">{{ this.label }}</h4>
                    </md-card-header>
                    <form-content :errors="errors" :document-type="documentType"></form-content>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning"
                                   @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>

        <div class="md-layout-item md-size-66" v-if="documentType.parent_id === null">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <div class="card-icon">
                                <i class="md-icon fas fa-layer-group"/>
                            </div>
                            <h4 class="title">Liste des sous-catégories liées</h4>
                        </div>
                        <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                            <div class="flex items-center">
                                <md-button class="md-info md-sm md-datatable" @click="goToRoute('Add Document SubType', documentType.id, 'idType')">
                                    <md-icon class="material-icons mr-1">add</md-icon>
                                    <span>Ajouter une sous-catégorie</span>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </md-card-header>
                <md-card-content class="mt-2">
                    <md-table v-if="documentType.children.length > 0" v-model="documentType.children" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <template v-if="item.parent_id !== null">
                                <md-table-cell md-label="#">{{ item.id }}</md-table-cell>
                                <md-table-cell md-label="Nom" style="min-width: 350px">{{ item.name }}</md-table-cell>
                                <md-table-cell md-label="État">
                                    <span :class="item.is_active ? 'text-success' : 'text-danger'">
                                        {{ isActive(item.is_active) }}
                                    </span>
                                </md-table-cell>
                                <md-table-cell md-label="Poids" style="max-width: 30px">
									<div class="edit-order">
										<md-field class="md-invalid md-parent-field">
											<md-input v-model="item.order" name="order" type="number" @keyup.enter="updateDocumentTypeOrder(item); $event.target.blur()"></md-input>
										</md-field>
									</div>
								</md-table-cell>
                                <md-table-cell md-label="">
                                    <div class="w-full flex items-center justify-center">
                                        <div>
                                            <md-button class="md-icon-button md-raised md-warning"
                                                       @click="goToRoute('Edit Document SubType', item.id, 'idSubType')">
                                                <i class="md-icon fa fa-pen"/>
                                            </md-button>
                                            <md-tooltip md-direction="top">Gérer</md-tooltip>
                                        </div>
                                    </div>
                                </md-table-cell>
                            </template>
                        </md-table-row>
                    </md-table>
                    <div v-else>
                        Aucune sous-catégorie liée détectée.
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <div class="md-layout-item md-size-100">
            <documents-table
                :documents-data="documentType.documents"></documents-table>
        </div>

    </div>
</template>

<script>
import FormContent from "@/pages/Documents/Type/components/FormContent";
import DocumentsTable from "@/pages/Documents/components/DocumentsTable";

export default {
    name: "TypeEdit",
    components: {
        FormContent, DocumentsTable
    },
    data() {
        return {
        	id: null,
            documentType: {
                children: [],
                documents: []
            },
			order: 0,
            errors: [],
            label: 'Modification d\'une catégorie'
        }
    },
    methods: {
        async updateDocumentType() {
            let documentType = {
                ...this.documentType,
                name: this.documentType.name.toUpperCase(),
                isActive: this.documentType.isActive,
                order: parseInt(this.documentType.order)
            }
			if(this.order !== documentType.order) {
				await this.$store.dispatch('documents/updateDocumentTypeOrder', documentType)
			}
            try {
                this.errors = null
                await this.$store.dispatch('documents/updateDocumentType', documentType)
                await this.$store.dispatch("alerts/success", "Catégorie modifiée");
                this.$router.go(-1);
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
		async updateDocumentTypeOrder(type) {
			let documentType = {
				...type,
				order: parseInt(type.order)
			}
			try {
				const { data } = await this.$store.dispatch('documents/updateDocumentTypeOrder', documentType)
				if(data === 'same order') {
					await this.$store.dispatch('alerts/warning', 'Poids identique')
				} else {
					await this.$store.dispatch('alerts/success', 'Poids modifié')
					await this.getData()
				}
			} catch (e) {
				await this.$store.dispatch('alerts/error', e.response.data.errors[0].detail)
			}
		},
        async getDocumentTypeDetails(id) {
            const { data } = await this.$store.dispatch('documents/getDocumentTypesDetails', id)
            this.documentType = {
                ...data,
                isActive: !!data.is_active,
                parentId: data.parent_id
            }
			this.order = _.cloneDeep(data.order)
        },
        isActive(state) {
            return state ? "Actif" : "Inactif"
        },
        goToRoute(route, id, param) {
            this.$router.push({ name: route, params: { [param]: id }})
        },
        goBack() {
            this.$router.go(-1)
        }
    },
    mounted() {
        this.id = this.$route.params.idSubType ?? this.$route.params.idType
        this.getDocumentTypeDetails(this.id)
        if(this.$route.params.idSubType) {
            this.label = 'Modification d\'une sous-catégorie'
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-datatable {
        max-height: 33px;
        min-height: 33px;
        width: 100%;

        .md-ripple {
            padding: 0 1rem !important;
        }
    }

    .md-layout-actions.md-layout-item {
        padding-right: 0;
    }

    .md-button-content {
        i {
            font-size: 1.1rem !important;
            height: 17px !important;
            width: 15px !important;
            min-width: 15px !important;
        }

        span {
            height: 17px;
            line-height: 18px;
        }
    }

    .md-table-cell-container .md-button {
        width: auto;

        .md-icon {
            font-size: .875rem !important;
            min-width: .875rem !important;
            height: .875rem !important;
        }
    }

    .md-table-head .md-table-head-label {
        color: #00bcd4 !important;
    }

    .md-list.md-dense {
        padding: 0;
        margin-top: .5rem;

        .md-list-item-content.md-ripple {
            min-height: 25px;
            padding: 0 15px;

            .md-icon {
                font-size: .25rem !important;
                min-width: .25rem !important;
                height: .25rem !important;
                color: rgba(0, 0, 0, .54) !important;
            }

            .md-icon:first-child {
                margin-right: .5rem;
            }

            span {
                position: relative;
                font-weight: 300;
                font-size: 14px;
            }
        }
    }

	.edit-order {
		.md-field {
			margin-top: 0;
			padding-bottom: 5px;
			input {
				width: 100%;
				height: 20px;
				padding: 0 !important;
			}
			input[type=number] {
				-moz-appearance: textfield;
			}

			&:before, &:after {
				bottom: 4px;
			}
		}
	}
}
</style>
